<template>
  <div class="header">
    <router-link class="header__logo" :to="{ name: 'main' }">
      <div class="header__logo_icon">
        <img src="~/assets/images/logo.png" alt="logo"/>
      </div>
      <div class="header__logo_title">
        <span>Женя</span>
        <span>Кужавська</span>
      </div>
    </router-link>
    <div v-for="menuItem in menuItems" :key="menuItem.routeName" class="header__menu">
      <router-link class="header__menu-item" :to="{ name: menuItem.routeName }" exact-active-class="header__menu-item--active">
        {{ menuItem.title }}
      </router-link>
    </div>
    <div
      v-if="false"
      class="header__cart"
      @mouseenter="isHoveredCartIcon = true"
      @mouseleave="isHoveredCartIcon = false"
      @click="showCartPopup"
    >
      <div class="header__cart-counter">{{ orderItems.length }}</div>

      <svg v-if="!isHoveredCartIcon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.994141" width="60" height="60" fill="white"/>
        <path d="M52.6337 15.6414C52.4356 15.1258 51.8571 14.8685 51.3416 15.0665C50.826 15.2646 50.5686 15.8431 50.7667 16.3586L52.6337 15.6414ZM58.0665 35.3586L58.4252 36.2921L60.2921 35.5748L59.9335 34.6414L58.0665 35.3586ZM50.7667 16.3586L58.0665 35.3586L59.9335 34.6414L52.6337 15.6414L50.7667 16.3586Z" fill="black"/>
        <path d="M11.459 16.3684C11.6624 15.855 11.4111 15.2738 10.8977 15.0703C10.3843 14.8669 9.8031 15.1182 9.59963 15.6316L11.459 16.3684ZM2.07034 34.6316L1.70193 35.5613L3.56126 36.2981L3.92966 35.3684L2.07034 34.6316ZM9.59963 15.6316L2.07034 34.6316L3.92966 35.3684L11.459 16.3684L9.59963 15.6316Z" fill="black"/>
        <line x1="10.9941" y1="16" x2="10.9941" y2="56" stroke="black" stroke-width="2" stroke-linecap="square"/>
        <line x1="51.4941" y1="15" x2="51.4941" y2="57" stroke="black" stroke-width="2"/>
        <line x1="9.99414" y1="56" x2="51.9941" y2="56" stroke="black" stroke-width="2"/>
      </svg>

      <svg v-if="isHoveredCartIcon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.994141" width="60" height="60" fill="white"/>
        <line x1="10" y1="14" x2="52.5" y2="14" stroke="black" stroke-width="2"/>
        <line x1="10.9941" y1="16" x2="10.9941" y2="56" stroke="black" stroke-width="2" stroke-linecap="square"/>
        <line x1="51.4941" y1="15" x2="51.4941" y2="57" stroke="black" stroke-width="2"/>
        <line x1="9.99414" y1="56" x2="51.9941" y2="56" stroke="black" stroke-width="2"/>
      </svg>

      <div v-for="index in Math.min(orderItems.length, 3)" :key="index" class="header__cart-book-icon" :style="{ bottom: `${8 + (index - 1) * 12}px` }">
        <svg width="33" height="10" viewBox="0 0 33 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1C1 1 18.8403 1 30.2715 1C32.6149 3.49447 32.5371 6.78056 30.2715 9H1" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
          <line x1="2.15" y1="1" x2="2.15" y2="9" stroke="black" stroke-width="0.3"/>
        </svg>
      </div>
    </div>
    <div class="header__mobile-menu">
      <div class="header__mobile-burger" @click="toggleMobileMenu()">
        <svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2 2H28" stroke="black" stroke-width="3" stroke-linecap="round"/>
          <path d="M2 24H28" stroke="black" stroke-width="3" stroke-linecap="round"/>
          <path d="M2 13H28" stroke="black" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </div>
      <div v-if="isOpenedMobileMenu" v-on-clickaway="hideMobileMenu" class="header__mobile-navigation">
        <div class="header__mobile-menu-items">
          <router-link class="header__mobile-menu-item" :to="{ name: 'main' }" exact-active-class="header__mobile-menu-item--active">
            Головна
          </router-link>
          <router-link
            v-for="menuItem in menuItems"
            :key="menuItem.routeName"
            class="header__mobile-menu-item"
            exact-active-class="header__mobile-menu-item--active"
            :to="{ name: menuItem.routeName }"
          >
            {{ menuItem.title }}
          </router-link>
          <div v-if="false" class="header__mobile-menu-item" @click="hideMobileMenu(); showCartPopup();">
            <span>Кошик</span>
            <div class="header__mobile-counter">{{ orderItems.length }}</div>
          </div>
        </div>
        <hr>
        <div class="header__mobile-socials">
          <a href="https://t.me/harold_blooom" target="_blank">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_12_289)">
                <path d="M11.944 3.26667e-05C8.77112 0.0148396 5.73324 1.28566 3.4949 3.53449C1.25656 5.78332 -3.4549e-05 8.82711 7.12435e-10 12C7.12441e-10 15.1826 1.26428 18.2349 3.51472 20.4853C5.76515 22.7358 8.8174 24 12 24C15.1826 24 18.2348 22.7358 20.4853 20.4853C22.7357 18.2349 24 15.1826 24 12C24 8.81743 22.7357 5.76519 20.4853 3.51475C18.2348 1.26431 15.1826 3.26667e-05 12 3.26667e-05C11.9813 -1.08889e-05 11.9627 -1.08889e-05 11.944 3.26667e-05ZM16.906 7.22403C17.006 7.22203 17.227 7.24703 17.371 7.36403C17.4667 7.44713 17.5277 7.56311 17.542 7.68903C17.558 7.78203 17.578 7.99503 17.562 8.16103C17.382 10.059 16.6 14.663 16.202 16.788C16.034 17.688 15.703 17.989 15.382 18.018C14.686 18.083 14.157 17.558 13.482 17.116C12.426 16.423 11.829 15.992 10.804 15.316C9.619 14.536 10.387 14.106 11.062 13.406C11.239 13.222 14.309 10.429 14.369 10.176C14.376 10.144 14.383 10.026 14.313 9.96403C14.243 9.90203 14.139 9.92303 14.064 9.94003C13.958 9.96403 12.271 11.08 9.003 13.285C8.523 13.615 8.09 13.775 7.701 13.765C7.273 13.757 6.449 13.524 5.836 13.325C5.084 13.08 4.487 12.951 4.539 12.536C4.566 12.32 4.864 12.099 5.432 11.873C8.93 10.349 11.262 9.34403 12.43 8.85903C15.762 7.47303 16.455 7.23203 16.906 7.22403Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_12_289">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </a>
          <a href="https://facebook.com/profile.php?id=100005047294995" target="_blank">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 12.073C24 5.446 18.627 0.072998 12 0.072998C5.373 0.072998 0 5.446 0 12.073C0 18.063 4.388 23.027 10.125 23.927V15.542H7.078V12.072H10.125V9.43C10.125 6.423 11.917 4.761 14.658 4.761C15.97 4.761 17.344 4.996 17.344 4.996V7.949H15.83C14.339 7.949 13.874 8.874 13.874 9.823V12.073H17.202L16.67 15.543H13.874V23.928C19.612 23.027 24 18.062 24 12.073Z" fill="black"/>
            </svg>
          </a>
          <a href="https://www.instagram.com/zhenya_kuzh/" target="_blank">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 0C8.74 0 8.333 0.015 7.053 0.072C5.775 0.132 4.905 0.333 4.14 0.63C3.351 0.936 2.681 1.347 2.014 2.014C1.347 2.681 0.935 3.35 0.63 4.14C0.333 4.905 0.131 5.775 0.072 7.053C0.012 8.333 0 8.74 0 12C0 15.26 0.015 15.667 0.072 16.947C0.132 18.224 0.333 19.095 0.63 19.86C0.936 20.648 1.347 21.319 2.014 21.986C2.681 22.652 3.35 23.065 4.14 23.37C4.906 23.666 5.776 23.869 7.053 23.928C8.333 23.988 8.74 24 12 24C15.26 24 15.667 23.985 16.947 23.928C18.224 23.868 19.095 23.666 19.86 23.37C20.648 23.064 21.319 22.652 21.986 21.986C22.652 21.319 23.065 20.651 23.37 19.86C23.666 19.095 23.869 18.224 23.928 16.947C23.988 15.667 24 15.26 24 12C24 8.74 23.985 8.333 23.928 7.053C23.868 5.776 23.666 4.904 23.37 4.14C23.064 3.351 22.652 2.681 21.986 2.014C21.319 1.347 20.651 0.935 19.86 0.63C19.095 0.333 18.224 0.131 16.947 0.072C15.667 0.012 15.26 0 12 0ZM12 2.16C15.203 2.16 15.585 2.176 16.85 2.231C18.02 2.286 18.655 2.48 19.077 2.646C19.639 2.863 20.037 3.123 20.459 3.542C20.878 3.962 21.138 4.361 21.355 4.923C21.519 5.345 21.715 5.98 21.768 7.15C21.825 8.416 21.838 8.796 21.838 12C21.838 15.204 21.823 15.585 21.764 16.85C21.703 18.02 21.508 18.655 21.343 19.077C21.119 19.639 20.864 20.037 20.444 20.459C20.025 20.878 19.62 21.138 19.064 21.355C18.644 21.519 17.999 21.715 16.829 21.768C15.555 21.825 15.18 21.838 11.97 21.838C8.759 21.838 8.384 21.823 7.111 21.764C5.94 21.703 5.295 21.508 4.875 21.343C4.306 21.119 3.915 20.864 3.496 20.444C3.075 20.025 2.806 19.62 2.596 19.064C2.431 18.644 2.237 17.999 2.176 16.829C2.131 15.569 2.115 15.18 2.115 11.985C2.115 8.789 2.131 8.399 2.176 7.124C2.237 5.954 2.431 5.31 2.596 4.89C2.806 4.32 3.075 3.93 3.496 3.509C3.915 3.09 4.306 2.82 4.875 2.611C5.295 2.445 5.926 2.25 7.096 2.19C8.371 2.145 8.746 2.13 11.955 2.13L12 2.16ZM12 5.838C8.595 5.838 5.838 8.598 5.838 12C5.838 15.405 8.598 18.162 12 18.162C15.405 18.162 18.162 15.402 18.162 12C18.162 8.595 15.402 5.838 12 5.838ZM12 16C9.79 16 8 14.21 8 12C8 9.79 9.79 8 12 8C14.21 8 16 9.79 16 12C16 14.21 14.21 16 12 16ZM19.846 5.595C19.846 6.39 19.2 7.035 18.406 7.035C17.611 7.035 16.966 6.389 16.966 5.595C16.966 4.801 17.612 4.156 18.406 4.156C19.199 4.155 19.846 4.801 19.846 5.595Z" fill="black"/>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway';
  import { createNamespacedHelpers } from 'vuex';

  const { mapState } = createNamespacedHelpers('cart');
  const { mapMutations } = createNamespacedHelpers('cart');

  export default {
    mixins: [clickaway],
    data() {
      return {
        isOpenedMobileMenu: false,
        isHoveredCartIcon: false,
        menuItems: [{
          title: 'Книги',
          routeName: 'books'
        }, {
          title: 'Екскурсії',
          routeName: 'excursions'
        }, {
          title: 'Курс',
          routeName: 'course'
        }]
      };
    },
    computed: {
      ...mapState({
        orderItems: (state) => state.orderItems
      })
    },
    watch: {
      $route() {
        this.hideMobileMenu();
      }
    },
    methods: {
      ...mapMutations({ showCartPopup: 'showPopup' }),
      toggleMobileMenu() {
        this.isOpenedMobileMenu = !this.isOpenedMobileMenu;
      },
      hideMobileMenu() {
        this.isOpenedMobileMenu = false;
      }
    }
  };
</script>

<style scoped lang="scss">
  .header {
    width: 84%;
    margin: 0 auto;
    height: 80px;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    @media (max-width: 650px) {
      justify-content: space-between;
    }

    .header__logo {
      display: flex;
      align-items: center;
      margin-right: 10%;

      .header__logo_icon {
        margin-right: 13px;
        width: 46px;
        height: 34px;
      }

      .header__logo_title {
        font-size: 1.5rem;
        width: 132px;
      }

      &:hover {
        .header__logo_title span {
          border-bottom: 4px solid #fbff00;
        }
      }
    }

    .header__menu {
      font-weight: 400;
      font-size: 1.25rem;
      width: 20%;

      .header__menu-item {
        cursor: pointer;

        &.header__menu-item--active {
          font-weight: 500;
        }

        &:hover {
          border-bottom: 4px solid #fbff00;
        }
      }
    }

    .header__cart {
      margin-left: auto;
      position: relative;

      &:hover {
        cursor: pointer;
      }

      .header__cart-counter {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 24px;
        height: 24px;
        background-color: #FFF507;
        border-radius: 50%;

        color: black;
        font-weight: 400;
        font-size: 12px;
        line-height: 0;
        z-index: 2;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .header__cart-book-icon {
        position: absolute;
        left: 15px;
      }
    }

    .header__mobile-menu {
      display: none;

      .header__mobile-navigation {
        top: 80px;
        left: 0;
        position: absolute;
        width: 100%;
        background: white;
        z-index: 3000;
        padding: 20px 24px;
        filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.25));

        .header__mobile-menu-items {
          display: flex;
          flex-direction: column;
          align-items: center;

          .header__mobile-menu-item {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            font-weight: 400;
            font-size: 1.125rem;
            line-height: 22px;

            &.header__mobile-menu-item--active {
              font-weight: 500;
            }
          }

          .header__mobile-counter {
            width: 24px;
            height: 24px;
            background-color: #FFF507;
            border-radius: 50%;
            margin-left: 8px;

            color: black;
            font-weight: 400;
            font-size: 12px;
            line-height: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }
        }

        hr {
          width: 100%;
          margin: 0;
        }

        .header__mobile-socials {
          display: flex;
          justify-content: center;
          margin-top: 20px;

          a {
            margin: 0 8px;
          }
        }
      }
    }

    @media (max-width: 650px) {
      .header__menu {
        display: none;
      }

      .header__cart {
        display: none;
      }

      .header__mobile-menu {
        display: block;
      }
    }
  }
</style>
